import React from 'react';

import { StyledFaq, StyledFaqHeader, StyledFaqList } from './CartFaqStyles';

var _ref = React.createElement(
  StyledFaqHeader,
  null,
  'FAQS'
);

var _ref2 = React.createElement(
  'li',
  null,
  React.createElement(
    'a',
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: 'https://support.dormify.com/hc/en-us/articles/229474928-Processing-Time'
    },
    'When will I get my order?'
  )
);

var _ref3 = React.createElement(
  'li',
  null,
  React.createElement(
    'a',
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: 'https://support.dormify.com/hc/en-us/articles/115004831048-How-is-my-order-secure-'
    },
    'How is my order secured?'
  )
);

var _ref4 = React.createElement(
  'li',
  null,
  React.createElement(
    'a',
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: 'https://www.dormify.com/pages/buy-now-ship-later'
    },
    'Buy Now, Ship Later'
  )
);

var _ref5 = React.createElement(
  'li',
  null,
  React.createElement(
    'a',
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: 'https://support.dormify.com/hc/en-us'
    },
    'More Help'
  )
);

var CartFaq = function CartFaq() {
  return React.createElement(
    StyledFaq,
    null,
    _ref,
    React.createElement(
      StyledFaqList,
      null,
      _ref2,
      _ref3,
      window.Dormify.shipLaterEnabled && _ref4,
      _ref5
    )
  );
};

export default CartFaq;